import { ChangeDetectionStrategy, Component, inject, input, output, signal } from '@angular/core';
import {
  form,
  FormField,
  FormOptions,
  FormRoot,
  required,
  SchemaPathTree,
  TreeValidationResult,
} from '@angular/forms/signals';
import { PasswordVisibilityToggleComponent } from 'src/app/shared/components/password-visibility-toggle/password-visibility-toggle.component';
import { TranslatePipe } from '@ngx-translate/core';
import { AlertComponent } from 'src/app/shared/components/alert/alert.component';
import { FormFieldOnErrorDirective } from 'src/app/shared/directives/form-field-on-error/form-field-on-error.directive';
import { SignalFormService } from 'src/app/shared/services/signal-form/signal-form.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { PasswordLoginFormModel } from './password-login.model';

@Component({
  selector: 'app-login-password',
  templateUrl: './password-login.component.html',
  styleUrls: ['./password-login.component.scss'],
  imports: [
    PasswordVisibilityToggleComponent,
    TranslatePipe,
    FormField,
    FormRoot,
    FormFieldOnErrorDirective,
    AlertComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class PasswordLoginComponent {
  public authService = inject(AuthService);

  public active = input<number>(1);
  public incorrectPassword = input(false);
  public credentialSubmit = output<string>();
  public dismissIncorrectPassword = output<void>();

  public revealPassword = signal(false);

  formModel = signal<PasswordLoginFormModel>({ password: '' });
  formOptions: FormOptions<PasswordLoginFormModel> = SignalFormService.formSubmitOptions(
    this.submitPassword.bind(this),
  );
  form = form(this.formModel, this.#formValidation.bind(this), this.formOptions);

  public togglePasswordVisibility(): void {
    this.revealPassword.set(!this.revealPassword());
  }

  public async submitPassword(): Promise<TreeValidationResult> {
    this.credentialSubmit.emit(this.formModel().password);
    return undefined;
  }

  public reset(): void {
    this.formModel.set({ password: '' });
  }

  #formValidation(path: SchemaPathTree<PasswordLoginFormModel>): void {
    required(path.password);
  }
}
